var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinFilled = function SvgPinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.55 25.625 35.8 29.4v2.875H25.45V44.15L24 45.6l-1.425-1.45V32.275H12.2V29.4l3.95-3.775v-16.6h-2.5V6.15h20.4v2.875h-2.5z"
  })));
};
export default SvgPinFilled;